import React from "react";
import { cn } from "@/lib/utils";
const capabilities = [{
  title: "Technical Expertise",
  description: "Access a vetted database of engineers and specialized technicians trained in advanced industrial systems and infrastructure maintenance.",
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/Con7-scaled.jpg?v=3v3ojhp5xzd"
}, {
  title: "Manual Workforce",
  description: "Scale your operations with reliable, safety-certified personnel for manufacturing, construction, and high-volume logistics environments.",
  image: "https://robust-hedgehog.10web.cloud/wp-content/uploads/2026/03/IMG-20220207-WA0050.jpg?v=hqnqimwyzbm"
}, {
  title: "Project Management",
  description: "Expert site supervisors and coordinators who ensure productivity, shift compliance, and seamless operational flow on every project.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596514/img/skills_management.png"
}, {
  title: "Safety & Compliance",
  description: "Dedicated resources focused on health, safety, and regulatory alignment, protecting both your workforce and your operational integrity.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1596514/img/skills_compliance.png"
}];
export default function StrategicCapabilities() {
  return <section data-section-id="45414" id="skills-resource-hub" className={cn("dark text-foreground py-24 relative overflow-hidden", "bg-[#0F172A]")}>
      
    </section>;
}